import { useTranslation } from '@/i18n'

/**
 * フォームの label 末尾に付ける「（必須）」/「（任意）」の小さなマーカー。
 *
 *   `<label>名前 <FieldMarker required /></label>`
 *
 * - `required` 指定時: アクセント色 + bold で強調 (CSS `.field-marker--required`)
 * - 既定 (optional): 控えめな灰色 (CSS `.field-marker--optional`)
 * - 全角丸括弧で囲い、ラベルとの間に半角スペース 1 つを挟む。
 */
export interface FieldMarkerProps {
  /** `true` で 必須 マーカー、`false` (既定) で 任意 マーカー。 */
  required?: boolean
}

export const FieldMarker = ({ required = false }: FieldMarkerProps): JSX.Element => {
  const { t } = useTranslation()
  const label = required ? t('common.form.marker_required') : t('common.form.marker_optional')
  const cls = required ? 'field-marker field-marker--required' : 'field-marker field-marker--optional'

  return (
    <span className={cls} aria-hidden="true">
      （{label}）
    </span>
  )
}
